<ng-template ngFor let-element [ngForOf]="elements" [ngForTrackBy]="trackByIndex">
  <ng-container [ngSwitch]="element.elementLayout">

    <ng-container *ngSwitchCase="layoutType.FIELD">
      <ng-template visiblewhen [layoutObject]="element.field" [model]="model" [specFields]="specFields">
        <lm-field *ngIf="!element.field.cfgHidden"
          [layoutObject]="element.field"
          [layoutInfo]="layoutInfo"
          [lmColumnLayoutInfo]="lmColumnLayoutInfo"
          [specFields]="specFields"
          [placeHolder]="placeHolder"
          [model]="model"
          class="{{element.class}}"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-field>
      </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="layoutType.CHECK_CONTROL">
      <ng-template visiblewhen [layoutObject]="element.checkcontrol" [model]="model" [specFields]="specFields">
        <lm-checkcontrol *ngIf="!element.checkcontrol.cfgHidden"
          [layoutObject]="element.checkcontrol"
          [specFields]="specFields"
          [placeHolder]="placeHolder"
          [model]="model"
          [layoutInfo]="layoutInfo"
          [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
          [lmColumnLayoutInfo]="lmColumnLayoutInfo"
          class="{{element.class}} || field"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-checkcontrol>
      </ng-template>
    </ng-container>


    <ng-container *ngSwitchCase="layoutType.CAPTCHA_CONTROL">
      <ng-template visiblewhen [layoutObject]="element.captchaControl" [model]="model" [specFields]="specFields">
        <lm-captcha-control [layoutObject]="element.captchaControl"></lm-captcha-control>
      </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="layoutType.HEADER">
      <ng-template visiblewhen [layoutObject]="element.header" [model]="model" [specFields]="specFields">
        <lm-header
          [layoutObject]="element.header"
          [layoutInfo]="layoutInfo"
          [specFields]="specFields"
          [model]="model"
          [previousSiblingIsCollapsible]="element.previousSiblingIsCollapsibleHeader"
          class="{{element.class}}"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-header>
      </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="layoutType.MANUAL_REPRESENTATION">
      <ng-template visiblewhen [layoutObject]="element.manualrep" [model]="model" [specFields]="specFields">
          <lm-manual-representation
              [manualRep]="element.manualrep"
              class="{{element.class}}"
              [model]="model"
              (fieldEvent)="onFieldEvent($event)"
          ></lm-manual-representation>
      </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="layoutType.PARAGRAPH">
      <lm-paragraph
        [layoutObject]="element.paragraph"
        [layoutInfo]="layoutInfo"
        [lmColumnLayoutInfo]="lmColumnLayoutInfo"
        [specFields]="specFields"
        [placeHolder]="placeHolder"
        [model]="model"
        class="{{element.class}}"
        (fieldEvent)="onFieldEvent($event)"
      ></lm-paragraph>
    </ng-container>

    <ng-container *ngSwitchCase="layoutType.BUTTON">
      <ng-template visiblewhen [layoutObject]="element.button" [model]="model" [specFields]="specFields">
        <lm-button *ngIf="!element.button.cfgHidden"
          [layoutObject]="element.button"
          [specFields]="specFields"
          [model]="model"
          [layoutInfo]="layoutInfo"
          [lmColumnLayoutInfo]="lmColumnLayoutInfo"
          class="{{element.class}}"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-button>
      </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="layoutType.BLANK">
      <ng-template visiblewhen [layoutObject]="element.Blank" [model]="model" [specFields]="specFields">
        <div
          *ngIf="lmColumnLayoutInfo"
            lm-blankline
            class="{{element.class}}"
        >
        </div>
        <div *ngIf="!lmColumnLayoutInfo" lm-blankline></div>
      </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="layoutType.TEXT">
      <ng-template visiblewhen [layoutObject]="element.text" [model]="model" [specFields]="specFields">
        <lm-text
          [layoutObject]="element.text"
          [specFields]="specFields"
          [placeHolder]="placeHolder"
          [layoutInfo]="layoutInfo"
          [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
          [lmColumnLayoutInfo]="lmColumnLayoutInfo"
          [model]="model"
          class="{{element.class}} field"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-text>
      </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="layoutType.MENU">
      <ng-template visiblewhen [layoutObject]="element.menu" [model]="model" [specFields]="specFields">
        <lm-simple-card
          [automationId]="element.menu.automationId"
          [type]="element.menu.type"
          [specFields]="specFields"
          [model]="model"
          [scale]="element.menu.menuScale"
          [link]="element.menu.link"
          [showBackground]="false"
          [imageUrl] = "element.menu.image"
          [title]="element.menu.label"
          [description]="element.menu.description"
          [paragraphLayout]="false"
          [isLink]="element.menu.isLink"
          [isExternalLink]="element.menu.external"
          [allowScannableSearch]="element.menu.allowScannableSearch"
          [openWhenSingleResult]="element.menu.openWhenSingleResult"
          class="{{element.class}} field"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-simple-card>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-template>
